import { Platform } from 'APP/wsApi/wsAppApi/types/common/common_model_pb';

export interface ILoginResult {
  isSuccess: boolean;
  error?: Error;
}

export interface IRefreshTokenResult extends ILoginResult {
  token: string | null;
}

export interface ILoginDeviceInfo {
  deviceId: string;
  platform: Platform;
  device: string;
  osVersion: string;
  osName: string;
  appVersion: string;
  locale: string;
}

export enum RefreshTokenInitiator {
  WsApp = 'wsApp',
  WsCalls = 'wsCalls',
}
